import $ from 'jquery';

$(document).on('click', '.inline-modal-content__button', function() {
  $(this).parent().parent().hide();
});
